import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './paymentController.json';

const queryPaymentInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['paymentController/queryPaymentInfo'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const getFastLoginInfo = (req, res, ctx) => {
  const responseData = MOCK_DATA['paymentController/getFastLoginInfo'].success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('paymentController/queryPaymentInfo'), withScenario(withAuthCheck(queryPaymentInfo))),
  rest.post(getApiEndpoint('paymentController/getFastLoginInfo'), withScenario(getFastLoginInfo)),
];
